"use client";import{jsxs as t,jsx as i}from"react/jsx-runtime";import{twMerge as e}from"tailwind-merge";import{useState as o}from"react";import{SystemIcon as s}from"../../DataDisplays/SystemIcon/SystemIcon.js";import"../../DataDisplays/SystemIcon/SystemIcon.constants.js";import{Box as r}from"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";import"@wishket/yogokit";import"react-dom";import{RichTooltip as a}from"../../Feedbacks/RichTooltip/RichTooltip.js";import"../../Feedbacks/GlobalLoadingIndicator/GlobalLoadingIndicator.js";
/**
 * 정보 아이콘과 함께 리치 툴팁을 표시하는 래퍼 컴포넌트입니다.
 *
 * @component
 * @param {Object} props - 컴포넌트 프로퍼티
 * @param {'sm' | 'md'} [props.size='md'] - 정보 아이콘의 크기 (sm, md)
 * @param {'right' | 'down'} [props.variant='right'] - 툴팁이 표시될 방향 (right, down)
 * @param {string} [props.title] - 툴팁의 제목
 * @param {string} [props.description] - 툴팁의 설명 텍스트
 * @param {React.ReactNode} [props.children] - 툴팁 내부에 표시될 컨텐츠
 * @param {string} [props.className] - 툴팁 컨테이너에 적용될 추가 클래스
 *
 * @example
 * // 기본 사용법
 * <WithRichTooltip
 *   title="결제 정보"
 *   description="신용카드 또는 계좌이체로 결제가 가능합니다."
 * />
 *
 * // 크기와 방향 지정
 * <WithRichTooltip
 *   size="sm"
 *   variant="down"
 *   title="배송 안내"
 *   description="주문 후 1-3일 내 배송됩니다."
 * >
 *   <p>추가 배송 정보는 여기에 표시됩니다.</p>
 * </WithRichTooltip>
 */const m=({size:m="md",variant:n="right",title:c,description:l,children:d,className:p})=>{const h="md"===m?"medium_information":"small_information",g="right"===n,f="down"===n,[y,u]=o(!1);/*#__PURE__*/
return t(r,{className:"relative h-fit w-fit","data-testid":"design-system-withRichTooltip",children:[
/*#__PURE__*/i(r,{"data-testid":"design-system-withRichTooltip--trigger",className:"flex h-fit w-fit shrink-0 items-center justify-center",onMouseEnter:()=>u(!0),onMouseLeave:()=>u(!1),onClick:()=>u((t=>!t)),children:/*#__PURE__*/i(s,{name:h,className:"text-w-gray-400",testId:"md"===m?"design-system-withRichTooltip--trigger-icon-md":"design-system-withRichTooltip--trigger-icon-sm"})}),y&&/*#__PURE__*/i(a,{title:c,description:l,className:e("absolute",g&&"left-[calc(100%_+_12px)] top-0",f&&"left-0 top-[calc(100%_+_12px)]",p),children:d})]})};export{m as WithRichTooltip};
